import { createFileRoute } from "@tanstack/react-router";
import Schedule from "@/pages/Schedule";

export const Route = createFileRoute("/_authenticated/schedule")({
  head: () => ({
    meta: [
      { title: "Baanindeling | De Hussel App" },
      { name: "description", content: "Bekijk de live baanindeling van je hussel-sessie." },
      { property: "og:title", content: "Baanindeling | De Hussel App" },
      { property: "og:description", content: "Bekijk de live baanindeling van je hussel-sessie." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Schedule,
});
